import React from "react";
import { PermissionGroupList } from "./PermissionGroupList";
import { RelativesList } from "./RelativesList";

interface Props {
    clubSlug: string;
}

export const ClubPermissionManagement: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ clubSlug }) => {
    return (
        <div className="tw-h-full tw-grid tw-flex-1 tw-grid-cols-1 tw-gap-3 sm:tw-grid-cols-3">
            <div className="tw-col-span-1 tw-flex tw-flex-col sm:tw-col-span-2">
                <RelativesList clubSlug={clubSlug} />
            </div>
            <div className="tw-flex tw-flex-col">
                <PermissionGroupList clubSlug={clubSlug} />
            </div>
        </div>
    );
};
